"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryTrigger = void 0;
/**
 * Indicates what triggered the query.
 *
 * @remarks
 * These values will likely change to be more relevant to the Answers Core.
 *
 * @alpha
 */
var QueryTrigger;
(function (QueryTrigger) {
    /** Indicates that query was triggered by a default initial search. */
    QueryTrigger["Initialize"] = "initialize";
    /** Indicates that the query was triggered by a search query in the URL params. */
    QueryTrigger["QueryParameter"] = "query-parameter";
})(QueryTrigger = exports.QueryTrigger || (exports.QueryTrigger = {}));
